import { useState, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import Container from "../components/ui/Container.js"
import useFetch from "../hooks/useFetch.js"
import { api } from "../services/api/index.js"

import "./Consigna.scss"

const QInput = ({ i, q }) => {
  const [correct, setCorrect] = useState(false),
    aa = q.accepted_answers.map((a) => a.toLowerCase())

  return (
    <>
      <span className="me-1" style={{ color: "grey" }}>
        {i}.
      </span>
      <span>{q.title}</span>
      <input
        type="text"
        className="form-control mt-2 w-100"
        onChange={(e) => setCorrect(aa.includes(e.target.value.toLowerCase()))}
        style={{
          background: correct ? "#afffaf" : "",
        }}
      />
    </>
  )
}

const QAStudentView = ({ qa }) => {
  const { t } = useTranslation()

  const f = (d) => new Date(Date.parse(d)).toLocaleDateString("es-UY")

  return (
    <>
      <Container>
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col col-lg-6 col-12">
              <center>
                <h3 className="mt-4">{qa.title}</h3>
                <i>{f(qa.timestamp)}</i>
              </center>

              <div className="form-group my-5">
                <h4 className="mb-4">{t(`admin.qa.text`)}</h4>
                <textarea
                  style={{ minHeight: "200px" }}
                  disabled={true}
                  defaultValue={qa.text}
                  className="form-control"
                  readonly></textarea>
              </div>

              <h4 className="form-label mt-4 mb-4">
                {t(`admin.qa.questions`)}
              </h4>

              <ul className="ps-0">
                {qa.questions
                  .filter((q) => q.checked === true)
                  .map((q, i) => (
                    <>
                      <li key={i} className="mb-4">
                        <QInput i={i + 1} q={q} />
                      </li>
                    </>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </Container>
    </>
  )
}

const QAView = () => {
  const { t } = useTranslation()
  const { id } = useParams(),
    { url, opt } = useMemo(() => api.qa.readOne({ id }), [id]),
    [qa, isPending, err] = useFetch({ url, opt })

  if (!id) return <Container />

  if (isPending && !err)
    return (
      <>
        <Container>
          <center>{t("ui.btns.loading")}...</center>
        </Container>
      </>
    )

  return <QAStudentView qa={qa} />
}

export default QAView
